import { render, staticRenderFns } from "./ControllerView.vue?vue&type=template&id=64aa8864&"
import script from "./ControllerView.vue?vue&type=script&lang=js&"
export * from "./ControllerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports